import ChatDialogueBox from '../Student/ChatDialogueBox'
import { ChatMode, TestChatType } from '@/constants/chat'
import type { OpenChatBox } from '@/redux/slices/testChatSlice'
import type { AIPlayerOpenChatBox } from '@/redux/slices/aiPlayerTestChatSlice'

interface ChatBoxesRendererProps {
  openChatBoxes: Array<OpenChatBox | AIPlayerOpenChatBox>
  onTestChatClose: () => void
  onCloseChatBox: (chatId: number) => void
  testChatType?: TestChatType
}

export default function ChatBoxesRenderer({
  openChatBoxes,
  onTestChatClose,
  onCloseChatBox,
  testChatType = TestChatType.Advisor,
}: ChatBoxesRendererProps) {
  return (
    <>
      {openChatBoxes.map((chatBox) => {
        if (chatBox.isTestChat) {
          return (
            <ChatDialogueBox
              key={chatBox.id}
              isOpen={true}
              onClose={onTestChatClose}
              participantNames='Test Chat'
              mode={ChatMode.TEST_CHAT}
              initialPosition={chatBox.position}
              testChatType={testChatType}
            />
          )
        } else {
          return (
            <ChatDialogueBox
              key={chatBox.id}
              isOpen={true}
              onClose={() => onCloseChatBox(chatBox.id)}
              participantNames={`Test Chat ${chatBox.id}`}
              mode={ChatMode.PREVIOUS_CHAT}
              isReadOnly={true}
              chatData={chatBox.chatData!}
              chatId={chatBox.id}
              initialPosition={chatBox.position}
              testChatType={testChatType}
            />
          )
        }
      })}
    </>
  )
}
